<section class="statement-page">
  <h1>Upload statement</h1>
  <p class="intro">Create a statement record and upload the source file for ingestion.</p>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <label>Statement type</label>
    <select formControlName="type">
      <option value="BANK">BANK</option>
      <option value="PROVIDER">PROVIDER</option>
    </select>

    <label>Source name</label>
    <input
      formControlName="sourceName"
      type="text"
      placeholder="e.g. fibank_jan_2026"
    />
    @if (sourceName.invalid && (sourceName.dirty || sourceName.touched)) {
      <div class="error">
        @if (sourceName.errors?.['required']) { <small>Source name is required.</small> }
        @if (sourceName.errors?.['maxlength']) { <small>Source name must not exceed 120 characters.</small> }
      </div>
    }

    <label>Statement file</label>
    <input type="file" (change)="onFileSelected($event)" />
    @if (!selectedFile && errorMessage === 'Please select a file to upload.') {
      <div class="error"><small>Please select a file to upload.</small></div>
    }

    <div class="actions">
      <button class="btn primary" type="submit" [disabled]="form.invalid || isSubmitting">
        {{ isSubmitting ? 'Uploading...' : 'Upload statement' }}
      </button>
      <a class="btn ghost" routerLink="/app">Back to dashboard</a>
    </div>
  </form>

  @if (errorMessage && errorMessage !== 'Please select a file to upload.') {
    <div class="message error-banner">{{ errorMessage }}</div>
  }
</section>
